// import ChatBot from './Components/ChatBot';
import { Spin } from 'antd';
import './App.css';
import React, { lazy, Suspense } from "react";

const ChatBot = lazy(() => import("./Components/ChatBot"));
function App() {


  // useEffect(() => {
  //   console.clear();
  //   console.log = () => {};
  //   console.warn = () => {};

  // },[])

  return (
    <div className="App">
  <Suspense
  fallback={
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh"
    }}>
      <Spin />
    </div>
  }
>
  <ChatBot />
</Suspense>
    </div>
  );
}

export default App;
